import request from '../../axios/axiosconfig.js'

export function getFeedbackType() {
  return request({
    url: '/ps/common/getFeedbackType',
    method: 'get'
  })
}
export function getFaultReportInfo(params) {
  return request({
    url: '/ps/faultReport/getFaultReportInfo',
    method: 'get',
    params: params
  })
}
export function handleFeedback(handleFeedbackDto) {
  return request({
    url: '/ps/faultReport/handleFeedback',
    method: 'post',
    params: handleFeedbackDto,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}


// WEBPACK FOOTER //
// ./src/api/oder/faultreport.js